import { FC, useContext, useState } from "react";
import NotificationDispatch, { showErrorNotification } from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useCarSubsidiariesApi } from "../../http/carSubsidiaries/api";
import ModalDialog from "../ui/ModalDialog";

type DeleteCarSubsidiaryDialogProps = {
  carSubsidiaryId: string;
  onClose: () => void;
  onUpdate: () => void;
  carId: string;
};

const DeleteCarSubsidiaryDialog: FC<DeleteCarSubsidiaryDialogProps> = ({
  carSubsidiaryId,
  onClose,
  onUpdate,
  carId,
}) => {
  const i18n = useI18n();
  const dispatch = useContext(NotificationDispatch);
  const carSubsidiariessApi = useCarSubsidiariesApi();
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <ModalDialog
      onClose={onClose}
      title={i18n.t.carSubsidiaries.delete}
      isSubmitting={isSubmitting}
      actions={[
        {
          title: i18n.t.common.cancel,
          type: "secondary",
          onClick: onClose,
        },
        {
          title: i18n.t.common.yes,
          onClick: () => {
            setIsSubmitting(true);
            carSubsidiariessApi
              .deleteCarSubsidiary(carSubsidiaryId, carId)
              .catch((err) => dispatch(showErrorNotification(i18n, err)))
              .then(() => {
                onClose();
                onUpdate();
              })
              .finally(() => setIsSubmitting(false));
          },
        },
      ]}
    >
      {i18n.t.carSubsidiaries.questions.delete}
    </ModalDialog>
  );
};

export default DeleteCarSubsidiaryDialog;
